import { LearningPathModuleResponseApi } from "../../ServerResponseType/LearningPath/LearningPathModule";

export interface LearningPathModuleRequestApi {
  learningPathModuleId: string;
  moduleId: string;
  order: number;
}

export class LearningPathModuleRequestImpl
  implements LearningPathModuleRequestApi
{
  learningPathModuleId: string;
  moduleId: string;
  order: number;

  constructor(learningPathModule: LearningPathModuleResponseApi) {
    this.learningPathModuleId = learningPathModule.learningPathModuleId;
    this.moduleId = learningPathModule.module.moduleId;
    this.order = learningPathModule.learningPathModuleOrder;
  }
}
